import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

// Register plugins
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

const initAnimations = () => {
    // Predefined animations
    document.querySelectorAll(".gsap-home-hero").forEach((el) => {
        const headline = el.querySelector(".headline");
        const logo = el.querySelector(".logo");

        const timeline = gsap.timeline();

        const headlineSplit = SplitText.create(headline, {
            type: "words,lines",
            linesClass: "line",
            autoSplit: true,
            mask: "lines",
        });

        timeline.from(headlineSplit.words, {
            duration: 0.8,
            yPercent: 100,
            stagger: 0.03,
            ease: "expo.out",
        });

        timeline.from(
            logo,
            {
                opacity: 0,
                scale: 0.95,
                y: 30,
                duration: 0.5,
                ease: "power2.out",
            },
            "-=0.6"
        );
    });

    document.querySelectorAll(".gsap-image-hero, .gsap-image-hero-job, .gsap-image-hero-event").forEach((el) => {
        const subHeadline = el.querySelector(".sub-headline");
        const headline = el.querySelector(".headline");
        const imageContainer = el.querySelector(".image-container");

        const timeline = gsap.timeline();

        timeline.from(subHeadline, {
            opacity: 0,
            y: 30,
            duration: 0.5,
            ease: "power2.out",
        });

        const headlineSplit = SplitText.create(headline, {
            type: "words,lines",
            linesClass: "line",
            autoSplit: true,
            mask: "lines",
        });

        timeline.from(
            headlineSplit.words,
            {
                duration: 0.8,
                yPercent: 100,
                stagger: 0.03,
                ease: "expo.out",
            },
            "-=0.25"
        );

        timeline.from(
            imageContainer,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power2.out",
            },
            "-=0.6"
        );
    });

    document.querySelectorAll(".gsap-image-hero-blog").forEach((el) => {
        const subHeadline = el.querySelector(".sub-headline");
        const headline = el.querySelector(".headline");
        const imageContainer = el.querySelector(".image-container");
        const author = el.querySelector(".author");
        const readingDuration = el.querySelector(".reading-duration");

        const timeline = gsap.timeline();

        timeline.from(subHeadline, {
            opacity: 0,
            y: 30,
            duration: 0.5,
            ease: "power2.out",
        });

        const headlineSplit = SplitText.create(headline, {
            type: "words,lines",
            linesClass: "line",
            autoSplit: true,
            mask: "lines",
        });

        timeline.from(
            headlineSplit.words,
            {
                duration: 0.8,
                yPercent: 100,
                stagger: 0.03,
                ease: "expo.out",
            },
            "-=0.25"
        );

        timeline.from(
            author,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power2.out",
            },
            "-=0.9"
        );

        timeline.from(
            readingDuration,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power2.out",
            },
            "-=0.6"
        );

        timeline.from(
            imageContainer,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power2.out",
            },
            "-=0.5"
        );
    });

    document.querySelectorAll(".gsap-image-hero-customer-service").forEach((el) => {
        const subHeadline = el.querySelector(".sub-headline");
        const headline = el.querySelector(".headline");
        const icon = el.querySelector(".icon");
        const imageContainer = el.querySelector(".image-container");
        const timeline = gsap.timeline();

        timeline.from(subHeadline, {
            opacity: 0,
            y: 30,
            duration: 0.5,
            ease: "power2.out",
        });

        const headlineSplit = SplitText.create(headline, {
            type: "words,lines",
            linesClass: "line",
            autoSplit: true,
            mask: "lines",
        });

        timeline.from(
            headlineSplit.words,
            {
                duration: 0.8,
                yPercent: 100,
                stagger: 0.03,
                ease: "expo.out",
            },
            "-=0.25"
        );

        timeline.from(
            icon,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power2.out",
            },
            "-=0.5"
        );

        timeline.from(
            imageContainer,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power2.out",
            },
            "-=0.6"
        );
    });

    document.querySelectorAll(".gsap-image-hero-shop").forEach((el) => {
        const subHeadline = el.querySelector(".sub-headline");
        const headline = el.querySelector(".headline");
        const logo = el.querySelector(".logo");
        const imageContainer = el.querySelector(".image-container");
        const timeline = gsap.timeline();

        timeline.from(subHeadline, {
            opacity: 0,
            y: 30,
            duration: 0.5,
            ease: "power2.out",
        });

        const headlineSplit = SplitText.create(headline, {
            type: "words,lines",
            linesClass: "line",
            autoSplit: true,
            mask: "lines",
        });

        timeline.from(
            headlineSplit.words,
            {
                duration: 0.8,
                yPercent: 100,
                stagger: 0.03,
                ease: "expo.out",
            },
            "-=0.25"
        );

        timeline.from(
            logo,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power2.out",
            },
            "-=0.5"
        );

        timeline.from(
            imageContainer,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power2.out",
            },
            "-=0.6"
        );
    });

    document.querySelectorAll(".gsap-text-hero").forEach((el) => {
        const headline = el.querySelector(".headline");
        const text = el.querySelector(".text");

        const timeline = gsap.timeline();

        const headlineSplit = SplitText.create(headline, {
            type: "words,lines",
            linesClass: "line",
            autoSplit: true,
            mask: "lines",
        });

        timeline.from(headlineSplit.words, {
            duration: 0.8,
            yPercent: 100,
            stagger: 0.03,
            ease: "expo.out",
        });

        if (!text) {
            return;
        }

        const textSplit = SplitText.create(text, {
            type: "words,lines",
            linesClass: "line",
            autoSplit: true,
            mask: "lines",
        });

        timeline.from(textSplit.words, {
            duration: 0.8,
            yPercent: 100,
            stagger: 0.03,
            ease: "expo.out",
        }, "-=0.5");
    });

    document.querySelectorAll(".gsap-customer-service-teaser").forEach((el) => {
        const headline = el.querySelector(".headline");
        const text = el.querySelector(".text");
        const link = el.querySelector(".link");

        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: "top 75%",
            },
        });

        timeline.from(headline, {
            opacity: 0,
            y: 30,
            duration: 0.5,
            ease: "power2.out",
        });

        const textSplit = SplitText.create(text, {
            type: "words,lines",
            linesClass: "line",
            autoSplit: true,
            mask: "lines",
            aria: "none",
        });

        timeline.from(
            textSplit.words,
            {
                duration: 0.8,
                yPercent: 100,
                stagger: 0.03,
                ease: "expo.out",
            },
            "-=0.25"
        );

        timeline.from(
            link,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power2.out",
            },
            "-=0.6"
        );
    });

    document.querySelectorAll(".gsap-customer-service-grid").forEach((el) => {
        const items = el.querySelectorAll(".customer-service");
        gsap.from(items, {
            opacity: 0,
            y: 30,
            duration: 0.5,
            ease: "power3.out",
            stagger: 0.1,
            delay: 0.25,
        });
    });

    document.querySelectorAll(".gsap-media-gallery").forEach((el) => {
        const items = el.querySelectorAll(".media-item");

        let mm = gsap.matchMedia();

        // screens.md
        mm.add("(min-width: 768px)", () => {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: "top 75%",
                    end: "bottom center",
                    scrub: true,
                },
            });

            timeline.to(
                items[1],
                {
                    y: 100,
                    ease: "power2.out",
                },
                "p"
            );

            timeline.to(
                items[2],
                {
                    y: -80,
                    ease: "power2.out",
                },
                "p"
            );

            timeline.to(
                items[3],
                {
                    y: 50,
                    ease: "power2.out",
                },
                "p"
            );
        });
    });

    document.querySelectorAll(".gsap-shop-filter").forEach((el) => {
        const categories = el.querySelectorAll(".category");
        const shops = el.querySelectorAll(".initial-shop");
        const link = el.querySelector(".link");

        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: "top 75%",
            },
        });

        timeline.from(
            categories,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power3.out",
                stagger: 0.1,
            },
            "p"
        );

        timeline.from(
            shops,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power3.out",
                stagger: 0.1,
            },
            "p+=0.1"
        );

        timeline.from(
            link,
            {
                opacity: 0,
                y: 30,
                duration: 0.5,
                ease: "power3.out",
            },
            "p+=0.2"
        );
    });

    document.querySelectorAll(".gsap-footer").forEach((el) => {
        const logo = el.querySelectorAll(".logo");
        const background = el.querySelectorAll(".background");

        gsap.from(background, {
            opacity: 0,
            scrollTrigger: {
                trigger: el,
                start: "top bottom",
                end: "bottom bottom",
                scrub: true,
            },
        });

        gsap.from(logo, {
            opacity: 0,
            y: 30,
            scrollTrigger: {
                trigger: el,
                start: "bottom-=200px bottom",
                end: "bottom bottom",
                scrub: true,
            },
        });
    });
};

if (!document.documentElement.classList.contains("editmode")) {
    document.fonts.ready.then(() => {
        initAnimations();
    });
}

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
